<template>
	<div
	  class="pt-2 pb-2 clearfix"
	  :class="containerClass"
	  v-touch:tap="tapHandler"
	  @keyup.enter="tapHandler"
	  tabindex="0"
	  role="link"
	>
	  <template v-if="data">
		<p class="mt-0 mb-0">
		  <strong>{{ showDate(data.treatmentsession_dateoftreatment) }}</strong> -
		  <!--strong>{{ studentName }}</strong-->
		</p>
		<template v-for="response in data.responses">
		  <span
			:key="response.id"
			class="badge badge-pill badge-primary mr-2"
			:class="{
			  'badge-primary': response.response_type == 0,
			  'badge-danger': response.response_type == -1,
			  'badge-success': response.response_type == 1,
			  'btn-emoji': response.response_emoji
			}"
		  >
			{{ response.response_emoji ? String.fromCodePoint(response.response_emoji) : response.response_text }}
		  </span>
		</template>
	  </template>
	  <template v-else>
		<div class="float-left">
		  <div class="skeleton midnight h20 w200 mb-3"></div>
		  <div class="skeleton midnight h20 w50"></div>
		</div>
		<div class="float-right">
		  <div class="skeleton midnight h20 w200"></div>
		</div>
	  </template>
	</div>
  </template>
  
  <script>
  export default {
	//inject: ['getStudentList'],
	props: ['data', 'selectedItem'],
	methods: {
	  tapHandler() {
		if (this.data) {
		  this.$emit('selectItem', this.data);
		}
	  },
	  showDate(date) {
		if (this.$UserSession.hasPriv.call(this, 'MYTREATMENTSESSIONFEEDBACK_IDENTIFY')) {
		  return this.$datetime.getLocaleStringFromTimeStamp(date);
		} else {
		  return this.$datetime.getMonthYearStringFromTimestamp(date);
		}
	  }
	},
	computed: {
	  containerClass() {
		const classArr = [];
		if (this.selectedItem && this.selectedItem.id === this.data.id) {
		  classArr.push('active');
		}
		return classArr.join(' ');
	  }
	}
  };
  </script>
  